module.exports = __webpack_public_path__ + "static/media/model-guide.8aebfcf7.png";